import { render, staticRenderFns } from "./All-Courses.vue?vue&type=template&id=4ffb1087"
import script from "./All-Courses.vue?vue&type=script&lang=js"
export * from "./All-Courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports